import { render, staticRenderFns } from "./IneligibleToReApply.vue?vue&type=template&id=0b6b4554&scoped=true&"
import script from "./IneligibleToReApply.vue?vue&type=script&lang=js&"
export * from "./IneligibleToReApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b4554",
  null
  
)

export default component.exports